import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { api, apiBaseUrl } from "@/shared/api";
import { startZohoSignIn } from "../model/zoho-verifier";

const KNOWN_ERRORS = ["zoho_state", "zoho_denied", "zoho_failed", "zoho_no_account"];

/** "Sign in with Zoho" under the password form, plus the reason when Zoho sent the person back unsuccessfully. */
export function ZohoSignIn({ error }: { error: string | null }) {
  const { t } = useTranslation();
  const providers = useQuery({
    queryKey: ["auth", "providers"],
    queryFn: async () => (await api.GET("/auth/providers")).data ?? { zoho: false },
    staleTime: 10 * 60_000,
    retry: false,
  });
  const failure = error && KNOWN_ERRORS.includes(error) ? error : null;
  if (!providers.data?.zoho && !failure) return null;
  return (
    <div className="mt-4 flex flex-col gap-3">
      {failure ? (
        <p role="alert" className="text-sm text-danger">
          {t(`auth.${failure}`)}
        </p>
      ) : null}
      {providers.data?.zoho ? (
        <>
          <div className="flex items-center gap-3 text-xs text-muted">
            <span className="h-px flex-1 bg-border" />
            {t("auth.or")}
            <span className="h-px flex-1 bg-border" />
          </div>
          {/* A full navigation, not a fetch: the browser goes to Zoho and comes back to finish signing in. */}
          <button
            type="button"
            onClick={() => void startZohoSignIn(`${apiBaseUrl}/auth/zoho/login`)}
            className="inline-flex h-10 items-center justify-center rounded-md border border-border px-4 text-sm font-medium hover:bg-surface-subtle"
          >
            {t("auth.signInZoho")}
          </button>
        </>
      ) : null}
    </div>
  );
}
